import Fila from 'components/3catinfo/Fila';
import Contenidor from 'components/3catinfo/Contenidor';
import CallToAction from 'components/3catinfo/CallToAction';
import DestacatTendenciesClimatiques from 'components/3catinfo/ElTemps/DestacatTendenciesClimatiques';

const getContent = (type) => {
    if (type === 'crisi-climatica' || type === 'medi-ambient') {
        return (
            <Fila columnes='12'>
                <DestacatTendenciesClimatiques />
            </Fila>
        );
    } else if (type === 'verificacio') {
        return (
            <Fila columnes='6_6' tipus='fixed'>
                <CallToAction
                    titol='Has rebut alguna cosa que et grinyola?'
                    text="Envia'ns un whatsapp al 677 07 09 40"
                    boto={{
                        iconaDreta: false,
                        text: 'Whatsapp',
                        icona: 'whatsappGran',
                        iconaBlanc: false,
                        href: 'https://wa.me/?text=3CatInfo',
                        novaFinestra: true,
                        fons: 'fonsContenidorNegre'
                    }}
                />
                <CallToAction
                    titol='Eines de verificació'
                    text='Recursos útils per combatre les notícies enganyoses'
                    boto={{
                        text: 'Ves-hi ara',
                        route: {
                            type: 'web_3catinfo_estatiques_subseccio',
                            slug: 'verificacio',
                            slug2: 'eines'
                        },
                        fons: 'fonsContenidorNegre'
                    }}
                />
            </Fila>
        );
    } else if (type === 'catalunya') {
        <Fila columnes='12' tipus='fixed'></Fila>;
    }
    return <></>;
};

export default function BlocComodiSeccio(props) {
    const { tipus } = props;
    const type = tipus || props?.routerQuery?.slug;
    return getContent(type);
}
